import type { TOC } from '@ember/component/template-only';
import { PrismLoadingBar } from '@mylighthouse/prism-ember';
import { or } from 'ember-truth-helpers';
import SettingsPreferredRatePreferredRate from 'lumen/components/settings/preferred-rate/preferred-rate';
import type HotelSettingPreferredRateController from 'lumen/controllers/hotel/settings/preferred-rate';

interface HotelSettingPreferredRateSignature {
  Args: {
    controller: HotelSettingPreferredRateController;
    model: unknown;
  };
}

<template>
  {{! The card clones the preference and reads the options in field initialisers,
      so both requests have to land before it is constructed }}
  {{#if
    (or
      @controller.model.requestPricingAssistantRatePreferencesOptionsTaskResult.isRunning
      @controller.model.ratePreferenceTaskResult.isRunning
    )
  }}
    <PrismLoadingBar />
  {{else}}
    {{#if
      (or
        @controller.model.saveAndUpdatePreferredRateSettings.isRunning
        @controller.model.launchRatePreferenceSimulateRequestTask.isRunning
        @controller.model.primaSettingsInProgressTaskResult.isRunning
      )
    }}
      <PrismLoadingBar />
    {{/if}}

    <SettingsPreferredRatePreferredRate
      @hasUserChangedPreferredRateSettingsValue={{@controller.hasUserChangedPreferredRateSettingsValue}}
      @model={{@controller.model}}
      @updateHasUserChangedPreferredRateSettingsValue={{@controller.updateHasUserChangedPreferredRateSettingsValue}}
    />
  {{/if}}
</template> satisfies TOC<HotelSettingPreferredRateSignature>;
